import type { ReactNode } from "react";
import { parseQuinnArtifact } from "../../utils/artifacts.ts";
import { QuinnArtifactCard } from "./QuinnArtifactCard.tsx";
import { useQuinnArtifactCanvas } from "./QuinnArtifactCanvasContext.tsx";

type QuinnArtifactSlotProps = {
    kind: "chart" | "table";
    raw: string;
    children: ReactNode;
};

export function QuinnArtifactSlot({ kind, raw, children }: QuinnArtifactSlotProps) {
    const canvas = useQuinnArtifactCanvas();
    const artifact = canvas ? parseQuinnArtifact(kind, raw, "") : null;
    if (!canvas || !artifact) return <>{children}</>;
    return (
        <QuinnArtifactCard
            artifact={artifact}
            isOpen={canvas.activeArtifactId === artifact.id}
            onOpen={() => canvas.openArtifact(artifact.id)}
        />
    );
}
